import { render, staticRenderFns } from "./JulyEnd.vue?vue&type=template&id=20c995f7&scoped=true&"
import script from "./JulyEnd.vue?vue&type=script&lang=js&"
export * from "./JulyEnd.vue?vue&type=script&lang=js&"
import style0 from "./JulyEnd.vue?vue&type=style&index=0&id=20c995f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c995f7",
  null
  
)

export default component.exports